import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import AddFarm from "components/Modal/AddFarm";
import UploadFile from "components/Modal/UploadFile";

const CreateNewFarmContainer = ({
  buttonColor,
  buttonType,
  buttonLabel,
  buttonIcon,
  buttonSize,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [farmName, setFarmName] = useState("");
  const [openUploadFile, setOpenUploadFile] = useState(false);

  const createNewFarm = () => {
    setIsOpenModal(true);
    setFarmName("");
  };

  const closeModal = () => {
    setIsOpenModal(false);
    setOpenUploadFile(false);
    setFarmName("");
  };

  const handleChangeStatus = () => {};

  return (
    <>
      <div className="farm-details-actions">
        <Button
          onClick={() => createNewFarm()}
          color={buttonColor}
          type={buttonType}
          label={buttonLabel}
          icon={buttonIcon}
          size={buttonSize}
          block
        />
      </div>
      <AddFarm
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        onClose={closeModal}
        setFarmDetails={setFarmName}
        buttonAction={() => setOpenUploadFile(true)}
      />
      {openUploadFile ? (
        <UploadFile
          isOpen={openUploadFile}
          onRequestClose={closeModal}
          onClose={closeModal}
          farmName={farmName}
          show="New"
          handleChangeStatus={() => handleChangeStatus}
        />
      ) : null}
    </>
  );
};

CreateNewFarmContainer.propTypes = {
  buttonType: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonIcon: PropTypes.string.isRequired,
  buttonSize: PropTypes.string.isRequired,
};

export default CreateNewFarmContainer;
